import { isDefined } from "./is-defined";

export function stringFormat(value: string, ...args: any[]): any {
    
    if (isDefined(args[0]) && args.length) {
        return value.replace(/{(\d+)}/g, (_, index) => args[index] || '')
    }

    return value;
}

export function deepCopy(obj) {
    if (obj === null || typeof obj !== 'object') {
        // Return the value if obj is not an object or array
        return obj;
    }

    // Create an array or object to hold the values
    let copy = Array.isArray(obj) ? [] : {};

    // Recursively copy each item in the object or array
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepCopy(obj[key]);
        }
    }

    return copy;
}
